import Vuex from 'vuex'
import Vue from 'vue'
import './plugins/NIM_Web_SDK_v5.9.0/js/NIM_Web_SDK_v5.9.0'
import emojiObj from './configs/emoji'
import formatTime from './services/formatTime'
let _ = require('lodash')
let $ = require('jQuery')

Vue.use(Vuex)

let taskInfo = {
  business_id: null, // 商家ID
  currency: 'USD', // 货币
  currency_symbol: '$',
  area: null, // 收获地区
  goods_list: [],
  amount: 0, // 商品费用
  tax_amount: 0, // 消费税
  transport_amount: 0, // 商家运费
  other_amount: 0, // 金额调整
  total_amount: 0, // 总计金额
  coupon: [], // 优惠码
  address_id: null, // 收获地址ID
  address_info: null,
  conditions: null,
  payment_type_id: null, // 支付方式ID
  payment_type_info: {},
  editConfirmProduct: false,
  business_name: '',
  totalCount: 0, // 购物车数量
  support_transport_service: '1', // 是否支持转运服务，1 支持，2不支持
  mobiletype: false
}

let localTaskInfo = localStorage.getItem('taskInfo') || '{}'
if (window.location.href.indexOf('buyer') > -1) {
  localTaskInfo = localStorage.getItem('taskInfo') || '{}'
} else {
  localTaskInfo = sessionStorage.getItem('taskInfo') || '{}'
}
localTaskInfo = JSON.parse(localTaskInfo)
let getLocalTaskInfo = function () {
  localTaskInfo = localStorage.getItem('taskInfo') || '{}'
  if (window.location.href.indexOf('buyer') === -1) {
    localTaskInfo = sessionStorage.getItem('taskInfo') || '{}'
  }
  return JSON.parse(localTaskInfo)
}

const store = new Vuex.Store({
  state: {
    articleKeyword:'',
    curPackageId:'',
    needUpload:false,
    isOpenDialog:false,
    single_type:'0',
    taxPercent:0,
    taskInfo: Object.assign({}, taskInfo, localTaskInfo),
    userInfo: {},
    messageDialog:{
      message:'',
      visible:false
    },
    globalDialog: {
      loginVisible: false,
      registerVisible: false,
      forgetPwdVisible: false,
      cartChangeVisible: false
    },
    nim: {
      sessions: [],
      msgs: [],
      showChat: false,
      pageType: null,
      toAccountId: null,
      users: [],
      sessionEnable: false,
      unread: false,
      accountOnlineStatesObj: {},
      accountOnlineStates: []
    }
  },
  mutations: {
    setArticleKeyword:(state,data)=>{
      state.articleKeyword=data
    },
    setPackageId:(state,data)=>{
      state.curPackageId=data
    },
    setNeedUpload:(state,data)=>{
      state.needUpload=data
    },
    updateOpenDialog:(state,data)=>{
      state.isOpenDialog=data
    },
    updateMessageDialog:(state,data) =>{
      state.messageDialog=data
    },
    updateSingleType: (state,data) =>{
      state.single_type=data
    },
    updateTaxPercent: (state, data) => {
      state.taxPercent = data
    },
    refreshTaskInfo: (state, data) => {
      state.taskInfo = Object.assign({}, taskInfo, getLocalTaskInfo())
    },
    updateTaxPercent: (state, key) => {
      state.globalDialog[key] = !state.globalDialog[key]
    },
    updateTaskInfo: (state, data) => {
      Object.assign(state.taskInfo, data)
      if (window.location.href.indexOf('Goods') > -1) {
        localStorage.setItem('taskInfo', JSON.stringify(state.taskInfo))
        return
      }
      if (window.location.href.indexOf('goods') > -1) {
        localStorage.setItem('taskInfo', JSON.stringify(state.taskInfo))
        return
      }
      if (window.location.href.indexOf('item') > -1) {
        localStorage.setItem('taskInfo', JSON.stringify(state.taskInfo))
        return
      }
      if (window.location.href.indexOf('buyer') > -1) {
        localStorage.setItem('taskInfo', JSON.stringify(state.taskInfo))
      } else {
        sessionStorage.setItem('taskInfo', JSON.stringify(state.taskInfo))
      }
    },
    clearTaskInfo: (state, data) => {
      taskInfo = {
        business_id: null, // 商家ID
        currency: 'USD', // 货币
        currency_symbol: '$',
        area: null, // 收获地区
        goods_list: [],
        amount: 0, // 商品费用
        tax_amount: 0, // 消费税
        transport_amount: 0, // 商家运费
        other_amount: 0, // 金额调整
        total_amount: 0, // 总计金额
        coupon: [], // 优惠码
        address_id: null, // 收获地址ID
        address_info: null,
        conditions: null,
        payment_type_id: null, // 支付方式ID
        payment_type_info: {},
        editConfirmProduct: false,
        business_name: '',
        totalCount: 0, // 购物车数量
        support_transport_service: '1', // 是否支持转运服务，1 支持，2不支持
        mobiletype: false
      }
      state.taskInfo = Object.assign({}, taskInfo)
      if (window.location.href.indexOf('buyer') > -1) {
        localStorage.setItem('taskInfo', JSON.stringify(state.taskInfo))
      } else {
        sessionStorage.setItem('taskInfo', JSON.stringify(state.taskInfo))
      }
    },
    updateUserInfo: (state, data) => {
      Object.assign(state.userInfo, data)
      // console.log('state.userInfo', state.userInfo)
      // localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    },
    clearUserInfo: (state, data) => {
      state.userInfo = {}
      // console.log('state.userInfo', state.userInfo)
      // localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    },
    showGlobalDialog: (state, key) => {
      console.log(key)
      _.each(state.globalDialog, (v, k) => {
        if (key === k) {
          return
        }
        state.globalDialog[k] = false
      })
      state.globalDialog[key] = true
      // setTimeout(() => {
      //   _.each(state.globalDialog, (v, k) => {
      //     if (key === k) {
      //       return
      //     }
      //     state.globalDialog[k] = false
      //   })
      // }, 100)
      // console.log(state.globalDialog[key])
    },
    hideGlobalDialog: (state, key) => {
      state.globalDialog[key] = false
    },
    updateNim: (state, options = {}) => {
      // state.nim.showChat = isShow]
      if (!options.showChat) {
        options.toAccountId = null
        options.pageType = null
      }
      _.merge(state.nim, options)
    },
    setNim (state, options) {
      let nim = SDK.NIM.getInstance({
        debug: window.env === 'test',
        appKey: window.env === 'test' ? 'e1d56def2b736f1b92eba61a3ddb98d4' : '0f3c7d0489b37814373bbf14317db805',
        account: options.accid,
        token: options.token,
        db: true,
        onpushevents: function (param) {
          _.each(param.msgEvents, item => {
            if (item.type === '1') {
              state.nim.accountOnlineStatesObj[item.account] = item.value
            }
          })
          state.nim.accountOnlineStates.splice(0, state.nim.accountOnlineStates.length)
          _.each(state.nim.accountOnlineStatesObj, (v, k) => {
            if (v === '1') {
              state.nim.accountOnlineStates.push(k)
            }
          })
          console.log('订阅事件', state.nim.accountOnlineStatesObj, state.nim.accountOnlineStates)
        },
        onfriends: function (users) {
          state.nim.users = users
          let accounts = []
          _.each(users, user => {
            console.log('user.accountuser.account', user.account)
            accounts.push(user.account)
          })
          if (accounts.length) {
            console.log('subscribeEventsubscribeEventsubscribeEvent', accounts)
            subscribeEvent(accounts)
          }
        },
        onsyncfriendaction: function (obj) {
          switch (obj.type) {
            case 'addFriend':
              console.log('你在其它端直接加了一个好友' + obj.account + ', 附言' + obj.ps)
              state.nim.users.unshift(obj.friend)
              break
            case 'passFriendApply':
              console.log('你在其它端通过了一个好友申请' + obj.account + ', 附言' + obj.ps)
              state.nim.users.unshift(obj.friend)
              break
          }
        },
        onmyinfo: function (user) {
          console.log('收到我的名片', user)
          state.nim.user = user
        },
        ondisconnect: function (obj) {
          console.log('SDK 连接断开', obj)
        },
        onerror: function (error) {
          console.log('SDK 连接失败', error)
        },
        onsessions: function (sessions) {
          state.nim.sessions = nim.mergeSessions(nim.sessions, sessions)
          state.nim.sessionEnable = true
          if (state.nim.sessions) {
            for (let session of state.nim.sessions) {
              if (session.unread > 0) {
                state.nim.unread = true
              }
            }
          }
          console.log('收到会话列表1', sessions)
        },
        onUpdateSession: function (sessions) {
          state.nim.sessions = nim.mergeSessions(nim.sessions, sessions)
          state.nim.sessionEnable = true
          console.log('收到会话列表2', sessions)
        },
        onroamingmsgs: function (obj) {
          console.log('收到漫游消息', obj)
          nim.pushMsg(obj.msgs)
        },
        onofflinemsgs: function (obj) {
          console.log('收到离线消息', obj)
          nim.pushMsg(obj.msgs)
        },
        onmsg: function (msg) {
          console.log('收到消息', msg.scene, msg.type, msg)
          nim.pushMsg(msg)
          state.nim.unread = true

          if (state.nim.sessions && state.nim.sessions.length) {
            for (let session of state.nim.sessions) {
              if (session.id === msg.sessionId) {
                session.lastMsg = msg
                session.unread++
                break
              }
            }
          }
        }
      })

      nim.username = options.username

      function subscribeEvent (accounts) {
        // https://bbs.yunxin.163.com/forum.php?mod=viewthread&tid=435
        // 需要开通
        nim.subscribeEvent({
          // type 1 为登录事件，用于同步多端登录状态
          type: 1,
          accounts: accounts,
          subscribeTime: 3600 * 24 * 30,
          sync: true,
          done: function onSubscribeEvent (err, res) {
            if (err) {
              console.error('订阅好友事件失败', err)
            } else {
              console.info('订阅好友事件', res)
            }
          }
        })
      }

      nim.pushMsg = function (msgs) {
        if (!Array.isArray(msgs)) { msgs = [msgs] }
        console.log('msgsmsgsmsgsmsgsmsgs', msgs, state.nim.msgs)
        // var sessionId = msgs[0].sessionId
        state.nim.msgs = state.nim.msgs || []
        state.nim.msgs = nim.mergeMsgs(state.nim.msgs, msgs)
        if (state.nim.sessions && state.nim.sessions.length && msgs[0]) {
          let hasSession = false
          for (let session of state.nim.sessions) {
            let msg = msgs[0]
            if (session.id === msg.sessionId) {
              session.lastMsg = msg
              console.log('session.lastMsg', session.lastMsg.time)
              hasSession = true
              formatTime(session)
              break
            }
          }
          if (!hasSession) {
            let newSession = {
              id: msgs[0].sessionId,
              lastMsg: msgs[0],
              scene: msgs[0].scene,
              to: msgs[0].to,
              unread: 1,
              updateTime: +new Date(),
              user: msgs[0].user
            }
            formatTime(newSession)
            state.nim.sessions.push(newSession)
          }
        }
        _.each(state.nim.msgs, (item, idx) => {
          if (item.type === 'text') {
            if (/\[[^\]]+\]/.test(item.text)) {
              let emojiItems = item.text.match(/\[[^\]]+\]/g)
              emojiItems.forEach(text => {
                let emojiCnt = emojiObj.emojiList.emoji
                if (emojiCnt[text]) {
                  item.text = item.text.replace(text, `<img width="20" style="vertical-align: middle;" class="emoji-small" src="${emojiCnt[text].img}">`)
                }
              })
            }
          }
          item.nextMsg = Object.assign({}, state.nim.msgs[idx + 1] || {time: +new Date()})
          console.log('itemitemitem', item)
        })
        var container = $('#chat-msg-list')
        setTimeout(() => {
          if (!container[0]) {
            return
          }
          container.scrollTop(container[0].scrollHeight + 500)
        }, 200)
      }
      _.merge(state.nim, nim)
    }
  },
  actions: {
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store.js